import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13.5 21h-7.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8","key":"svg-0"}],["path",{"d":"M19 16l-2 3h4l-2 3","key":"svg-1"}],["path",{"d":"M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-2"}]]

const IconDeviceTabletBolt = createReactComponent('outline', 'device-tablet-bolt', 'DeviceTabletBolt', __iconNode);

export default IconDeviceTabletBolt;